import * as React from 'react';
import styled from 'styled-components';

import { toScreen } from '@doltech/core/lib/responsive/responsive.util';
import { deviceBreakpoints } from '../../../../hooks/useDeviceQuery.hook';
import { FreeUserSignUp } from '../../../Auth/FreeUserSignUp';
import { colorsV2 } from '../../../colors-v2';
import { HeaderActionSearch } from '../Header/HeaderActionSearch';
import { TopbarNavList } from '../Header/TopbarNavList/TopbarNavList';
import { LandingLayoutHeader } from '../LandingLayout';

const Main = styled(LandingLayoutHeader).withConfig({
  componentId: 'PremadeHeader_LandingHeaderFullWidth_Main',
} as any)`
  .fake-header {
    height: 64px;
  }
  padding: 0 16px;
  &.landing-header {
    display: grid;
    align-items: stretch;
    justify-content: center;
    grid-template-columns: 1fr;

    .landing-header-container {
      height: 64px;
      justify-content: space-between;
      display: grid;
      align-items: center;
      grid-auto-flow: column;
      grid-template-columns: max-content;
      gap: 24px;
      &.hide {
        padding: 0 16px;

        @media ${deviceBreakpoints.fromTablet} {
          padding: 0 24px;
        }

        @media ${deviceBreakpoints.fromDesktop} {
          padding: 0 32px;
        }

        filter: drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.04))
          drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.04)) drop-shadow(0px 0 1px rgba(0, 0, 0, 0.04));
        z-index: 1000;
        background: ${colorsV2.white100};
        width: 100%;
        grid-auto-flow: column;
        grid-template-columns: max-content;
        display: grid;
        position: fixed;
        top: 0;
        left: 0;
      }
    }

    .section-header {
      height: 100%;
      &-left,
      &-middle,
      &-right {
        display: grid;
        align-items: center;
        grid-auto-flow: column;
        grid-template-columns: max-content;
        gap: 12px;
      }

      &-middle {
        display: none;
        flex: 1;
        justify-content: flex-end;
      }
    }

    .btn-sidebar {
      display: flex;
    }
    @media ${deviceBreakpoints.fromTablet} {
      padding: 0 24px;
    }

    @media ${deviceBreakpoints.fromDesktop} {
      padding: 0 32px;
      &.landing-header {
        .landing-header-container {
          grid-template-columns: max-content 1fr max-content;

          .section-header {
            &-middle {
              display: grid;
            }
          }
        }
      }
      .btn-sidebar {
        display: none;
      }
    }
  }
`;

const FreeUserSignUpWrapper = styled.div`
  ${toScreen(425)} {
    display: none;
  }
`;

interface LandingHeaderFullWidthProps {
  logoColored?: boolean;
  showBanner?: boolean;
  id?: string;
}

export const LandingHeaderFullWidth = (props: LandingHeaderFullWidthProps) => {
  const { logoColored, ...rest } = props;

  return (
    <Main {...rest}>
      <div className="fake-header" />
      <div id="fixed" className="landing-header-container hide">
        <div className="section-header section-header-left">
          <LandingLayoutHeader.BtnSidebar />
          <LandingLayoutHeader.LogoContainer logoColored={logoColored} />
        </div>

        <div className="section-header section-header-middle">
          <TopbarNavList />
        </div>

        <div className="section-header section-header-right">
          <HeaderActionSearch />
          <FreeUserSignUpWrapper>
            <FreeUserSignUp />
          </FreeUserSignUpWrapper>
        </div>
      </div>
    </Main>
  );
};
